exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-2ca050a1],.fade-leave-active[data-v-2ca050a1]{transition:opacity .2s}.fade-enter[data-v-2ca050a1],.fade-leave-to[data-v-2ca050a1]{opacity:0}", ""]);

// exports
